import { HostListener, OnInit } from "@angular/core";
import { Component } from "@angular/core";
import { DateAdapter } from "@angular/material/core";
import { TranslateService } from "@ngx-translate/core";
import { SessionContextService } from "./context/session-context.service";
import { DataProvider } from "./providers/data.provider";
import { NavigationEnd, Router } from "@angular/router";
import { SpinnerService } from "shared-components";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  private readonly languages = ["es", "es-ES", "en-GB", "en-US"];
  public currentLanguage = window.navigator.language;
  private readonly _BREAKPOINT_SIZE_SCREEN = 1375;

  constructor(
    private readonly _translate: TranslateService,
    private readonly _sessionContext: SessionContextService,
    private readonly _spinnerService: SpinnerService,
    private readonly _dataProvider: DataProvider,
    private dateAdapter: DateAdapter<Date>,
    public router: Router
  ) {
    if (
      localStorage.defaultLanguage &&
      this.languages.includes(localStorage.defaultLanguage)
    )
      this.currentLanguage = localStorage.defaultLanguage;
    if (this.languages.includes(this.currentLanguage)) {
      this._translate.setDefaultLang(this.currentLanguage);
      this.dateAdapter.setLocale(this.currentLanguage);
    } else {
      this._translate.setDefaultLang("en-GB");
      this.dateAdapter.setLocale("en-GB");
    }
    router.events.subscribe((val) => {
      if (
        val instanceof NavigationEnd &&
        localStorage.getItem("url") &&
        val.url !== "/home" &&
        val.url !== "/" &&
        localStorage.getItem("url") != val.url &&
        val.url !== "/viewPdf"
      ) {
        localStorage.setItem("url", val.url);
      }
    });
    if (localStorage.getItem("refreshChangeLanguage")) {
      if (localStorage.getItem("refreshChangeLanguage") === "true") {
        localStorage.refreshChangeLanguage = "false";
      } else {
        localStorage.removeItem("refreshChangeLanguage");
        localStorage.removeItem("user");
        localStorage.removeItem("token");
      }
    }
  }

  async ngOnInit() {
    if (this.isSessionActive) {
      this._spinnerService.showSpinner();
      this.router.navigate(["home"]);
      this._sessionContext.loadedData = await this._dataProvider.load();
      this._spinnerService.hideSpinner();
      localStorage.url
        ? this.router.navigate([localStorage.url])
        : this.router.navigate([""]);
      if (localStorage.base64) this.router.navigate(["/viewPdf"]);
    }
    this._sessionContext.smallScreen =
      window.innerWidth <= this._BREAKPOINT_SIZE_SCREEN ? true : false;
  }

  @HostListener("window:resize")
  onWindowResize() {
    this._sessionContext.smallScreen =
      window.innerWidth <= this._BREAKPOINT_SIZE_SCREEN ? true : false;
  }

  public get isSessionActive() {
    return this._sessionContext.isSessionActive();
  }

  public get loadedData() {
    return this._sessionContext.loadedData;
  }

  public changeLanguange(language) {
    this._translate.use((this.currentLanguage = language));
  }
}
